import { RESEARCH_FAVICONS_API_PATH } from "../constants/research-favicons";
import type { IResearchFaviconsResponse } from "../types/research-favicons";
import type { ApiClient } from "./client";

// NOTE: NSAI-7336 — the icons beside Deep Research's sources, fetched and
// cached by the server. At most RESEARCH_FAVICONS_MAX_HOSTS_PER_REQUEST hosts
// per call; createResearchFaviconLoader batches the badges into such calls.
export class ResearchFaviconsApi {
  constructor(private readonly apiClient: ApiClient) {}

  async get(hosts: string[]): Promise<IResearchFaviconsResponse> {
    const response = await this.apiClient.get<IResearchFaviconsResponse>(
      RESEARCH_FAVICONS_API_PATH,
      { params: { hosts: hosts.join(",") } },
    );
    return response.data;
  }
}
